import { Routes } from '@angular/router';

export const MARKETING_PAGE_REDIRECTS = {
  music: 'music-artists'
} as const;

export const MARKETING_PAGE_REDIRECT_SLUGS = Object.keys(
  MARKETING_PAGE_REDIRECTS
) as Array<keyof typeof MARKETING_PAGE_REDIRECTS>;

export function getMarketingPageRedirectRoutes(
  publishedSlugs: readonly string[]
): Routes {
  const publishedByLower = new Map(
    publishedSlugs.map((slug) => [slug.toLowerCase(), slug])
  );

  return MARKETING_PAGE_REDIRECT_SLUGS.reduce<Routes>((routes, from) => {
    const target = publishedByLower.get(MARKETING_PAGE_REDIRECTS[from].toLowerCase());
    if (target) {
      routes.push({
        path: from,
        redirectTo: `/${target}`,
        pathMatch: 'full'
      });
    }
    return routes;
  }, []);
}
